import React from "react";
import { Div } from "components/Base";
import CollapsablePanel from "Portal/NewPortal/Shared/CollapsablePanel";
import { Label } from "EventLight/Common/FieldLayout";
import { Input } from "ui-kit/Form/View";

import { FIELD_IDS_ACTIVE_ACCOUNT } from "Portal/NewPortal/Sections/Profile/constants";
import { getFieldValueToShow } from "../../selectors";

const AccountWebLinks = ({
  visibleFieldIds,
  lockedFieldIds,
  data = {},
  updatedFieldValues = {}
}) => {
  if (
    !visibleFieldIds.includes(FIELD_IDS_ACTIVE_ACCOUNT.LINKEDIN_URL) &&
    !visibleFieldIds.includes(FIELD_IDS_ACTIVE_ACCOUNT.TWITTER_URL) &&
    !visibleFieldIds.includes(FIELD_IDS_ACTIVE_ACCOUNT.FACEBOOK_URL) &&
    !visibleFieldIds.includes(FIELD_IDS_ACTIVE_ACCOUNT.WEBSITE)
  ) {
    return null;
  }

  return (
    <Div display="column">
      <CollapsablePanel title="My Links">
        <Div display="column" p={5} style={{ gap: 16 }} width={1}>
          <Div
            display="column.flex-start.flex-start"
            width={1}
            style={{
              gap: 20
            }}
          >
            {visibleFieldIds.includes(FIELD_IDS_ACTIVE_ACCOUNT.LINKEDIN_URL) ? (
              <Div display="column" width={1}>
                <Label fs={2} color="neutral7">
                  LinkedIn URL
                </Label>
                <Input
                  fieldId={FIELD_IDS_ACTIVE_ACCOUNT.LINKEDIN_URL}
                  disabled={lockedFieldIds.includes(
                    FIELD_IDS_ACTIVE_ACCOUNT.LINKEDIN_URL
                  )}
                  iniValue={getFieldValueToShow({
                    data,
                    updatedData: updatedFieldValues,
                    fieldId: FIELD_IDS_ACTIVE_ACCOUNT.LINKEDIN_URL
                  })}
                  size="big"
                  type="text"
                  inputType="outline"
                  //placeholder="LinkedIn URL..."
                />
              </Div>
            ) : null}

            {visibleFieldIds.includes(FIELD_IDS_ACTIVE_ACCOUNT.TWITTER_URL) ? (
              <Div display="column" width={1}>
                <Label fs={2} color="neutral7">
                  X URL
                </Label>
                <Input
                  fieldId={FIELD_IDS_ACTIVE_ACCOUNT.TWITTER_URL}
                  disabled={lockedFieldIds.includes(
                    FIELD_IDS_ACTIVE_ACCOUNT.TWITTER_URL
                  )}
                  iniValue={getFieldValueToShow({
                    data,
                    updatedData: updatedFieldValues,
                    fieldId: FIELD_IDS_ACTIVE_ACCOUNT.TWITTER_URL
                  })}
                  size="big"
                  type="text"
                  inputType="outline"
                  //placeholder="Twitter URL..."
                />
              </Div>
            ) : null}

            {visibleFieldIds.includes(FIELD_IDS_ACTIVE_ACCOUNT.FACEBOOK_URL) ? (
              <Div display="column" width={1}>
                <Label fs={2} color="neutral7">
                  Facebook URL
                </Label>
                <Input
                  fieldId={FIELD_IDS_ACTIVE_ACCOUNT.FACEBOOK_URL}
                  disabled={lockedFieldIds.includes(
                    FIELD_IDS_ACTIVE_ACCOUNT.FACEBOOK_URL
                  )}
                  iniValue={getFieldValueToShow({
                    data,
                    updatedData: updatedFieldValues,
                    fieldId: FIELD_IDS_ACTIVE_ACCOUNT.FACEBOOK_URL
                  })}
                  size="big"
                  type="text"
                  inputType="outline"
                  //placeholder="Facebook URL..."
                />
              </Div>
            ) : null}

            {visibleFieldIds.includes(FIELD_IDS_ACTIVE_ACCOUNT.WEBSITE) ? (
              <Div display="column" width={1}>
                <Label fs={2} color="neutral7">
                  Website
                </Label>
                <Input
                  fieldId={FIELD_IDS_ACTIVE_ACCOUNT.WEBSITE}
                  disabled={lockedFieldIds.includes(
                    FIELD_IDS_ACTIVE_ACCOUNT.WEBSITE
                  )}
                  iniValue={getFieldValueToShow({
                    data,
                    updatedData: updatedFieldValues,
                    fieldId: FIELD_IDS_ACTIVE_ACCOUNT.WEBSITE
                  })}
                  size="big"
                  type="text"
                  inputType="outline"
                  //placeholder="Website..."
                />
              </Div>
            ) : null}
          </Div>
        </Div>
      </CollapsablePanel>
    </Div>
  );
};

export default AccountWebLinks;
